import ky from 'ky';

export class NetworkError extends Error {
  constructor(
    public readonly url: string,
    cause: unknown,
  ) {
    super(`Could not fetch ${url}`, { cause });
  }
}

export const baseApi = ky.extend({
  timeout: 10_000,
  retry: 2,
  async fetch(input, init) {
    try {
      return await fetch(input, init);
    } catch (error) {
      const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
      throw new NetworkError(url, error);
    }
  },
});

export default baseApi.extend({
  prefix: '/',
});
